// Airanet brand logo — official artwork
export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_field-execution-2/artifacts/njlrnbr1_AIRANET_Logo.jpg";

// Full lockup (wordmark + tagline baked into the image). Preferred everywhere.
export const Logo = ({ className = "h-9 w-auto" }) => (
  <img
    src={LOGO_URL}
    alt="Airanet India Pvt Ltd"
    className={`${className} rounded-md object-contain`}
  />
);

// Square-cropped version for tight spaces (About office section, tiles).
export const LogoMark = ({ className = "h-10 w-10" }) => (
  <img
    src={LOGO_URL}
    alt="Airanet India Pvt Ltd"
    className={`${className} rounded-md object-cover`}
    style={{ objectPosition: "left center" }}
  />
);

export default Logo;
